import { configureStore } from '@reduxjs/toolkit'

import authReducer from './auth';
import pricesAndPrizesReducer from './scratchgames';

const store = configureStore({
	reducer: { auth: authReducer, pricesAndPrizes: pricesAndPrizesReducer},
});

export default store;